import {HeaderMenuItem} from './header-menu-item';

export class HeaderMenuLink implements HeaderMenuItem {
  icon: any;
  title: any;
  url: any;

  constructor(title: string, url: string, icon: string) {
    this.title = title;
    this.url = url;
    this.icon = icon;
  }
}
